module.exports = __webpack_public_path__ + "static/media/chaat.71c15ef7.jpg";